import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';

import { LocationUsersState } from './location-users.state';

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'locationUsers', idKey: 'id' })
export class LocationUsersStore extends EntityStore<LocationUsersState> {
  constructor() {
    super();
  }
}
